import { GetterTree } from 'vuex'
import { TemplatesState } from './types';
import { RootState } from '@/store/types';

export const getters: GetterTree<TemplatesState, RootState> = {
  smsTemplates:state => state.smsTemplates,
  smsMultichannelTemplates:state => state.smsMultichannelTemplates,
  smsTemplateItem:state => state.smsTemplateItem,
};